import TFAnsModel from './TFAnsModel'

class AnsContainer {

    constructor() {
        this.tfAnsArr = [];

        this.selectedStyle = {}
        this.multipleAnswers = false

    }



    getAsJson = () => {
        let obj = {};
        let tfAnsArr = [];
        for (let i = 0; i < this.tfAnsArr.length; i++) {
            tfAnsArr.push(this.tfAnsArr[i].getReportAsJson());
        }

        obj.tfAnsArr = tfAnsArr;

        return obj;
    }

    initFromJson = (obj) => {

        let tfAnsArr = [];
        tfAnsArr = obj.tfAnsArr;
        this.tfAnsArr = [];
        for (let i = 0; i < tfAnsArr.length; i++) {

            let ansModel = new TFAnsModel();
            ansModel.initFromJson(tfAnsArr[i]);
            this.tfAnsArr.push(ansModel);
        }

        let counter = 0;
        for (let i = 0; i < this.tfAnsArr.length; i++) {
            if (this.tfAnsArr[i].isRight)
                counter++;
        }


        if (counter > 1) {
            this.multipleAnswers = true;
        }

    }


    initFromJsonTest4You = (obj) => {

        let tfAnsArr = JSON.parse(obj.tfAnsArr)
        let rightAns = JSON.parse(obj.rightAns)

        if (tfAnsArr["text"]) {
            let answers = tfAnsArr["text"]

            tfAnsArr = answers.trim().replace(/(\s+)/g, " ").split(" ")
        }
        else if (tfAnsArr["synoname"])//right or wrong question 
            tfAnsArr = tfAnsArr["synoname"]

        for (var key of Object.keys(tfAnsArr)) {

            let tFAnsModel = new TFAnsModel()
            tFAnsModel.ansIndex = parseInt(key) - 1
            // if (tfAnsArr[key].toLowerCase().trim() == "true")
            //     tFAnsModel.ansTxt = "صح"
            // else if (tfAnsArr[key].toLowerCase().trim() == "false")
            //     tFAnsModel.ansTxt = "خطأ"
            // else
            tFAnsModel.ansTxt = window.toAbsAllImgSrcs(tfAnsArr[key])

            this.tfAnsArr.push(tFAnsModel)
        }

        if (rightAns["text"]) {
            // rightAns = rightAns["text"].trim().split(' ')
            rightAns = rightAns["text"].trim().replace(/(\s+)/g, " ").split(" ")

            let rightIndex = 0
            rightAns.filter(function (item, index) {
                if (item.indexOf('<correct>') != -1) {
                    rightIndex = index
                    return item
                }
            })
            this.tfAnsArr[rightIndex].isRight = true
        }
        else if (rightAns["1"] && rightAns["1"].hasOwnProperty("Question")) { //right or wrong question
            for (var key of Object.keys(rightAns)) {
                this.tfAnsArr.map(answers => {
                    if (rightAns[key].Answer == answers.ansTxt)
                        answers.isRight = true
                })

            }
        }
        else {
            for (var key of Object.keys(rightAns)) {
                let isRightIndex = parseInt(key) - 1
                if (isRightIndex < this.tfAnsArr.length)
                    this.tfAnsArr[isRightIndex].isRight = true
                else
                    this.tfAnsArr[this.tfAnsArr.length - 1].isRight = true

            }
        }
        let rightAnsCounter = 0
        this.tfAnsArr.map((item, index) => {
            if (item.isRight)
                rightAnsCounter++
        })

        this.multipleAnswers = rightAnsCounter > 1 ? true : false
    }


    getReportAsJson = () => {
        return this.getAsJson();
    }

    initReportFromJson = (obj) => {
        let tfAnsArr = [];

        tfAnsArr = obj.tfAnsArr;
        //            this.tfAnsArr = new ArrayList<>();
        
        for (let i = 0; i < tfAnsArr.length; i++) {

                        //   let  ansModel = new TFAnsModel();

            this.tfAnsArr[i].initReportFromJson(tfAnsArr[i]);
            //                this.tfAnsArr.add(ansModel);
        }


    }

    styleModification = () => {
        this.selectedStyle[0].style.border = "solid 0px black"
        this.selectedStyle[0].style.paddingTop = "0px"
    }


}

export default AnsContainer